import './track-uploader-dropdown.sass';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import Switch from 'react-bootstrap-switch';
import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css';
import uuidV4 from 'uuid/v4';
import { Translate, I18n } from 'react-redux-i18n';

import FileInput from 'controls/file-input/FileInput';
import ContentLoader from 'controls/content-loader/ContentLoader';
import RecorderSelector from 'controls/recorder-selector/RecorderSelector';
import CalibrationSelector from 'controls/calibration-selector/CalibrationSelector';

import startEasyTrackUploading from 'actions/particular/startEasyTrackUploading';

import request from 'actions/request';
import redirect from 'actions/redirect';

class TrackUploaderDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShown: false,
      isReady: false,
      previewNeed: true,
      file: '',
    };
  }

  handleClickOutside(event) {
    if ((event.target.nodeName !== 'svg')
      && !event.target.ownerSVGElement
      && (event.target.className.includes('track-uploader-dropdown-toggle'))
      && !this.state.isShown
    ) {
      this.setState({ isShown: true });
    } else {
      this.setState({ isShown: false });
    }
  }

  handleChange() {
    let form = new FormData(this.sendTrackForm);
    let uploadingUid = uuidV4().substring(0, 18).replace(/-/g, '');

    form.append('uploadingUid', uploadingUid);

    if (this.state.previewNeed) {
      this.props.request(
        ['uploader', 'storeTrackFile'],
        'post',
        'TRACK_FILE',
        form
      ).then(() => {
        this.props.redirect('/uploading/' + uploadingUid
          + '/recorder-id/' + this.props.chosenRecorder.id
          + ((this.props.chosenCalibration && this.props.chosenCalibration.id)
            ? ('/calibration-id/' + this.props.chosenCalibration.id || '')
            : '')
        );
      });
    } else {
      form.append('recorderId', this.props.chosenRecorder.id);

      let chosenCalibrationId = '';

      if (this.props.chosenCalibration && this.props.chosenCalibration.id) {
        chosenCalibrationId = this.props.chosenCalibration.id;
      }

      this.props.startEasyUploading({
        form: form,
        recorderId: this.props.chosenRecorder.id,
        calibrationId: chosenCalibrationId,
        uploadingUid: uploadingUid
      });
    }

    this.setState({
      isShown: false,
      file: ''
    });
  }

  handleSwitchChange(event, state) {
    this.setState({
      previewNeed: state,
    });
  }

  render() {
    return <ul className={ "track-uploader-dropdown dropdown-menu " + ( this.state.isShown ? 'is-shown' : '' ) }>
      <li><a href="#"><b><Translate value='topMenu.trackUploaderDropdown.trackUploading'/></b></a></li>
      <RecorderSelector />
      <CalibrationSelector/>
      <li><a href="#">
        <span className="track-uploader-dropdown__switch-label"><Translate value='topMenu.trackUploaderDropdown.preview'/></span>
        <Switch
          value={ this.state.previewNeed }
          bsSize="mini"
          onText={ <Translate value='topMenu.trackUploaderDropdown.on'/> }
          offText={ <Translate value='topMenu.trackUploaderDropdown.off'/> }
          onChange={ this.handleSwitchChange.bind(this) }
        />
      </a></li>
      <li><a href="#">
        <form action="" ref={ (form) => { this.sendTrackForm = form; }}
          className={ this.state.isReady ? '' : 'track-uploader-dropdown__is-disabled'}
        >
          <FileInput
             className="btn btn-default"
             name="trackFile"
             placeholder={ I18n.t('topMenu.trackUploaderDropdown.chooseFile') }
             value={ this.state.file }
             onChange={ this.handleChange.bind(this) }
           />
        </form>
       </a></li>
    </ul>
  }
}

function mapStateToProps(state) {
  return {
    recordersPending: state.recorders.pending,
    recorders: state.recorders,
    chosenRecorder: state.recorders.chosen,
    chosenCalibration: state.calibrations.chosen
  }
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    redirect: bindActionCreators(redirect, dispatch),
    startEasyUploading: bindActionCreators(startEasyTrackUploading, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(onClickOutside(TrackUploaderDropdown));
